export default {
  faqPage: {
    title: 'FAQ',
    subtitle: 'よくある質問'
  }
};
